export const ERROR_MESSAGES = Object.freeze({
  missedCurrentCompany: 'Missed current company slug',
})
